import React from 'react';
import {
    Button,
    Space,
    Typography,
    List,
    Card,
    Tooltip, notification
} from "antd";
import {getFeConfig, updateEASInfo, visualize} from "../api/api";
import {CloseOutlined, EditOutlined, SaveOutlined} from "@ant-design/icons";
import {unstable_batchedUpdates} from "react-dom";
import {Q4USUtil} from "@q4us-sw/q4us-util";
import {resolve} from "@q4us-sw/q4us-ui/lib/Cell";
import {EditCellView, RowContext} from "@q4us-sw/q4us-ui/lib/TableV2";

export const Item = ({column, value: v, submit, allData}) => {

    const [edit, setEdit] = React.useState(false)
    const [display, setDisplay] = React.useState(v)
    const [value, setValue] = React.useState({data: {[column.name]: v}})
    const [ellipsis, setEllipsis] = React.useState(true);

    return <React.Fragment>
    <Card
        className={`eas-info-item`}
        title={<Tooltip title={column.title}>{column.title}</Tooltip>}
        extra={<Space>
            {(!edit) && <Button icon={<EditOutlined/>} key={"edit"} onClick={async () => {
                setEdit(true)
            }}/>}
            {edit && <Button icon={<SaveOutlined/>} key={"save"} onClick={async () => {
                const [[p, q]] = Object.entries(value.data);
                let res = {status: 200};
                if (submit) {
                    await submit({key: p, value: q}).catch(e => {
                        res = {status: 401}
                    })
                } else {
                    if (p === 'first_overdue_inv_notification') {
                        const secondOverdueNotification = allData['second_overdue_inv_notification'];

                        if (q < 2) {
                            notification.error({message: "First overdue invoice notification should be more than 2 days"});
                            res = {status : 406}
                        } else if (q > secondOverdueNotification - 2) {
                            notification.error({message: "There should be at least 2 days between First overdue invoice notification and Second invoice notification"});
                            res = {status : 406}
                        } else {
                            res = await updateEASInfo({key: p, value: q})
                        }
                    } else if (p === 'second_overdue_inv_notification') {
                        const firstOverdueNotification = allData['first_overdue_inv_notification'];

                        if (q - 2 < firstOverdueNotification) {
                            notification.error({message: "There should be at least 2 days between First overdue invoice notification and Second invoice notification"});
                            res = {status : 406}
                        } else {
                            res = await updateEASInfo({key: p, value: q})
                        }
                    } else {
                        res = await updateEASInfo({key: p, value: q})
                    }
                }

                if (res.status === 200) {
                    allData[p] = q;
                    unstable_batchedUpdates(() => {
                        setEdit(false)
                        setDisplay(q)
                    })
                } else {
                    unstable_batchedUpdates(() => {
                        setEdit(false)
                        setValue({data: {[column.name]: v}})
                    })
                }

            }}/>}
            {edit && <Button icon={<CloseOutlined/>} key={"close"} onClick={async () => {
                unstable_batchedUpdates(() => {
                    setEdit(false)
                    setValue({data: {[column.name]: v}})
                })
            }}/>}
        </Space>}
    >
        {(!edit) && <Typography.Text className={`eas-info-value`} style={
                ellipsis
                    ? {
                        width: 200
                    }
                    : undefined
                }
                     ellipsis={
                         ellipsis
                             ? {
                                 rows: 2,
                                 expandable: true,
                             }
                             : false
                     }>
            {column.type === 'NUMBER' && column.enums == null ? Q4USUtil.roundToDecimal((display || 0), column.precision).toFixed(column.precision) : resolve({
                ...column,
                value: display,
                precision: 2
            })}
        </Typography.Text>}
        {edit && <RowContext.Provider value={{edit: value, setEdit: setValue, row: value.data, index: 0}}>
            <EditCellView required={true} name={column.name} type={column.type} title={column.title} enums={column.enums}/>
        </RowContext.Provider>}
    </Card>
    </React.Fragment>
}

export const NotificationSettings = () => {
    const [opt, setOpt] = React.useState({config: [], data: {}})

    const load = async () => {
        const {data: {rows: config} = {}} = await getFeConfig('notification_settings') || {};
        const {data: {rows = []} = {}} = await visualize('eas_info') || {};

        const data = rows.reduce((acc, {name, value, type}) => {
            acc[name] = type === 'NUMBER' ? Number(value) : type === 'BOOLEAN' ? value === 'true' : value;
            return acc;
        }, {})
        setOpt({config, data})

    }

    React.useEffect(() => {
        load();
    }, [])

    return <React.Fragment>
        <div className={`eas-info-wrap`}>
            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 1,
                    md: 1,
                    lg: 2,
                    xl: 2,
                    xxl: 2
                }}
                dataSource={opt.config}
                renderItem={item => <List.Item>
                    <Item column={item} value={opt.data[item.name]}
                          submit={undefined} allData={opt.data}/>
                </List.Item>}
            />
        </div>
    </React.Fragment>
};
